import styled from 'styled-components';

import { PlaceholderWrapper } from '_utils/components';

export const Wrapper = styled(PlaceholderWrapper)``;
